import React, { Component } from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import {
  addSubUserMenuGroup,
  getSubUserMenuGroupSequence,
  getActiveRoles,
} from "./../../../config/general_api_calls";

import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import HelperClass from "./../../../config/helperClass";
import { THEME_TEXT_COLOR, THEME_COLOR } from "./../../../config/config";
import MutextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import Tooltip from "@material-ui/core/Tooltip";
import dateFormat, { masks } from "dateformat";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Select2 from "react-select";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

const auth = new HelperClass();

class CollateralsAddGroup extends Component {
  constructor() {
    super();
    this.state = {
      errorMessage: "",
      successMessage: "",
      tableLoader: true,
      disabled: false,
      group_title: "",
      group_desc: "",
      status: 0,
      allSeqValues: [],
      group_sequence: "",
      listRoleData: [],
      roleList: [],
      selectedRoles: [],
      selectAllRoles: false,
    };
  }

  viewBtns = () => {
    if (
      this.props.is_msa_signed === "No" ||
      this.props.defaultSettings === "missing"
    ) {
      return <VisibilityOffIcon />;
    } else {
      return <VisibilityIcon style={{ cursor: "pointer" }} />;
    }
  };

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mm-dd-yyyy, h:MM:ss TT");
  };

  async componentDidMount() {
    this.setState({
      errorMessage: "",
      successMessage: "",
      tableLoader: true,
    });
    const servicesResponce = await getSubUserMenuGroupSequence(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("Sequence Data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      const allSeqValues = servicesResponce.data.data;

      let nextAvailableSequence;

      if (allSeqValues.length === 0) {
        nextAvailableSequence = 1;
      } else {
        // Find the next available sequence value
        let maxSequence = Math.max(...allSeqValues);
        nextAvailableSequence = maxSequence + 1;
      }

      this.setState({
        allSeqValues: allSeqValues,
        group_sequence: nextAvailableSequence,
      });
    } else {
      // window.location.replace("/error");
    }
    this.getActiveRoles();
  }

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  handleChange = async (event) => {
    const { target } = event;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value,
    });
  };

  handleSequenceChange = async (event) => {
    const { target } = event;
    let value = target.value;
    let parsedValue = parseInt(value, 10);

    if (!parsedValue || parsedValue < 1) {
      this.setState({
        group_sequence_error: "The sequence must be 1 or greater",
        group_sequence: value,
      });
    } else {
      this.setState({
        group_sequence_error: "",
        group_sequence: value,
      });
    }
  };

  handleEditorProductDesc = (content, editor) => {
    this.setState({
      group_desc: content,
    });
  };

  formSave = async () => {
    window.scrollTo(0, 0);
    const { group_title, group_desc, group_sequence, status } = this.state;

    this.setState({ errorMessage: "" });

    if (group_title === "") {
      return this.setState({
        errorMessage: "Please enter the group title.",
        disabled: false,
      });
    } else if (group_desc === "") {
      return this.setState({
        errorMessage: "Please enter the group description.",
        disabled: false,
      });
    }

    const saveResponce = await addSubUserMenuGroup(
      auth.getAccount(),
      auth.getToken(),
      group_title,
      group_desc,
      group_sequence,
      status,
      this.state.selectedRoles.map((g) => g.value),
    );

    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (saveResponce.data.status === 404) {
      // window.location.replace("/error");
      this.setState({
        errorMessage: "There is some error while Adding the menu group.",
        successMessage: "",
        disabled: false,
      });
    } else if (saveResponce.data.status === 409) {
      this.setState({
        errorMessage: "Group title already in use. Please use a unique name.",
        successMessage: "",
        disabled: false,
      });
    } else if (
      saveResponce.data.status === 200 &&
      saveResponce.data.message === "success"
    ) {
      this.setState({
        errorMessage: "",
        successMessage: "Menu group created successfully.",
        disabled: false,
      });
      setTimeout(() => {
        localStorage.setItem("subUserMenuTab", "subadmin_menu_group");
        this.props.props.history.push("/admin_roles");
      }, 3000);
    } else {
      this.setState({
        errorMessage: saveResponce.data.message,
        successMessage: "",
        disabled: false,
      });
      //window.location.replace("/error");
    }
  };

  getActiveRoles = async () => {
    this.setState({ tableLoader: true });

    const listSubUserMenuGroups = await getActiveRoles(
      auth.getAccount(),
      auth.getToken(),
    );

    if (
      listSubUserMenuGroups.data.status === 403 ||
      listSubUserMenuGroups.data.errors === "authentication missing" ||
      listSubUserMenuGroups.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      listSubUserMenuGroups.data.status === 200 &&
      listSubUserMenuGroups.data.message === "success"
    ) {
      const rawRoles = listSubUserMenuGroups.data.data || [];

      const roleList = rawRoles.map((group) => ({
        value: group[1], // Assuming group[4] is ID
        label: group[0], // Assuming group[1] is name/title
      }));

      this.setState({
        listRoleData: rawRoles,
        roleList, // for Select2
        tableLoader: false,
      });
    } else {
      // handle error
    }
  };

  handleSelectAllRolesChange = (e) => {
    const { roleList } = this.state;
    const checked = e.target.checked;

    this.setState({
      selectAllRoles: checked, // <-- boolean only
      selectedRoles: checked ? roleList : [], // <-- fill or clear selection
    });
  };

  handleRoleSelectChange = (selectedOptions) => {
    const { roleList } = this.state;
    const allSelected = selectedOptions.length === roleList.length;
    this.setState({
      selectedRoles: selectedOptions,
      selectAllRoles: allSelected,
    });
  };

  render() {
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}
          {/* MODAL EDIT PROFILE START */}

          {/* MSA WARNING END */}
          <div className="nk-block-head nk-block-head-sm">
            <div className="nk-block-between">
              <div className="nk-block-head-content">
                <Breadcrumbs aria-label="breadcrumb">
                  <Link
                    color="inherit"
                    onClick={() => this.addMenuHistory("/")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <HomeIcon fontSize="inherit" className="" />
                    Home
                  </Link>
                  <Link
                    color="inherit"
                    onClick={() => {
                      localStorage.setItem(
                        "subUserMenuTab",
                        "subadmin_menu_group",
                      );
                      this.addMenuHistory("/admin_roles");
                    }}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    Menu Group
                  </Link>
                  <Typography color="textPrimary" className="">
                    Add Menu Group
                  </Typography>
                </Breadcrumbs>
              </div>
            </div>
          </div>
          <div className="nk-block">
            {/* Table 5th Col Start */}
            <div className="row g-gs">
              <div className="col-xxl-12">
                <div className="nk-block nk-block-lg">
                  <div className="card card-bordered">
                    <div className="card-inner">
                      {this.state.errorMessage !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessage !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <h5
                        className="card-title"
                        style={{ marginBottom: "45px" }}
                      >
                        Add Menu Group
                      </h5>
                      <form method="post" autoComplete="off" role="presentation" className="pageForm" id="pageForm">
                        <div className="row g-4">
                          <div
                            className="col-md-6 customStyle-sqnc-addGroup"
                            style={{ marginBottom: "20px" }}
                          >
                            <div className="form-group">
                              <div className="form-label-group">
                                <label className="form-label">
                                  <Tooltip
                                    title="Enter a descriptive name for this menu group."
                                    placement="right"
                                  >
                                    <em
                                      className="icon ni ni-info"
                                      style={{
                                        color: "#6576ff",
                                      }}
                                    ></em>
                                  </Tooltip>{" "}
                                  Group Title{" "}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <div className="form-control-group">
                                <MutextField
                                  required
                                  id="group_title"
                                  name="group_title"
                                  type="text"
                                  label=""
                                  value={this.state.group_title}
                                  onChange={this.handleChange}
                                  inputProps={{ maxLength: 100 }}
                                  variant="outlined"
                                  fullWidth
                                autoComplete="new-password"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6 customStyle-sqnc-addGroup">
                            <div className="form-group">
                              <div className="form-label-group">
                                <label className="form-label">
                                  <Tooltip
                                    title="Set whether this menu group is active or inactive"
                                    placement="right"
                                  >
                                    <em
                                      className="icon ni ni-info"
                                      style={{
                                        color: "#6576ff",
                                      }}
                                    ></em>
                                  </Tooltip>{" "}
                                  Status <span className="text-danger">*</span>
                                </label>
                              </div>
                              <div className="form-control-group">
                                <MutextField
                                  id="status"
                                  name="status"
                                  select
                                  label=""
                                  value={this.state.status}
                                  onChange={this.handleChange}
                                  SelectProps={{
                                    native: true,
                                  }}
                                  helperText=""
                                  variant="outlined"
                                  fullWidth
                                  required
                                autoComplete="new-password"
                                >
                                  <option key="0" value="0">
                                    Inactive
                                  </option>
                                  <option key="1" value="1">
                                    Active
                                  </option>
                                </MutextField>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-md-6 customStyle-sqnc-addGroup"
                            style={{ marginBottom: "20px" }}
                          >
                            <div className="form-group">
                              <div className="form-label-group">
                                <label className="form-label">
                                  <Tooltip
                                    title="Set the sequence of this group(e.g 1)."
                                    placement="right"
                                  >
                                    <em
                                      className="icon ni ni-info"
                                      style={{
                                        color: "#6576ff",
                                      }}
                                    ></em>
                                  </Tooltip>{" "}
                                  Sequence #{" "}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <div className="form-control-group">
                                <MutextField
                                  required
                                  id="group_sequence"
                                  name="group_sequence"
                                  type="number"
                                  value={this.state.group_sequence}
                                  variant="outlined"
                                  fullWidth
                                  disabled={true}
                                autoComplete="new-password"
                                />
                              </div>
                            </div>
                          </div>
                          {this.state.listRoleData &&
                            this.state.listRoleData.length > 0 && (
                              <div className="col-md-6 customStyle-sqnc-addGroup">
                                <div className="form-group">
                                  <div className="form-label-group">
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "baseline",
                                        justifyContent: "space-between",
                                        marginBottom: "1px",
                                      }}
                                    >
                                      {/* Left side - Sequence label */}
                                      <label
                                        className="form-label"
                                        style={{ margin: 0, fontWeight: "600" }}
                                      >
                                        <Tooltip
                                          title="Select menu items to include in this group. Use 'Select All' to choose all available items at once."
                                          placement="right"
                                        >
                                          <em
                                            className="icon ni ni-info"
                                            style={{
                                              color: "#6576ff",
                                              marginRight: "6px",
                                            }}
                                          ></em>
                                        </Tooltip>
                                        Menu Items{" "}
                                      </label>

                                      {/* Right side - Select All with cleaner design */}
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "12px",
                                          fontSize: "14px",
                                          color: "#8094ae",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontWeight: "400",
                                            marginLeft: "10px",
                                          }}
                                        >
                                          |
                                        </span>
                                        <label
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                            cursor: "pointer",
                                            margin: 0,
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            color: "#526484",
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={this.state.selectAllRoles}
                                            onChange={
                                              this.handleSelectAllRolesChange
                                            }
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                              accentColor: "#6576ff",
                                              cursor: "pointer",
                                            }}
                                          autoComplete="new-password" />
                                          Select All
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="form-control-group">
                                    <Select2
                                      id="selectedRoles"
                                      value={this.state.selectedRoles}
                                      isMulti
                                      name="groups"
                                      options={this.state.roleList}
                                      className="basic-multi-select"
                                      classNamePrefix="select"
                                      onChange={this.handleRoleSelectChange}
                                      placeholder="Select one or more menu items"
                                      styles={{
                                        control: (base) => ({
                                          ...base,
                                          minHeight: "55px",
                                          borderColor: "#ced4da",
                                          boxShadow: "none",
                                          fontSize: "14px",
                                        }),
                                        menu: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                        placeholder: (base) => ({
                                          ...base,
                                          color: "#8094ae",
                                        }),
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          <div className="col-md-12 customStyle-sqnc-addGroup">
                            <div className="form-group">
                              <div className="form-label-group">
                                <label className="form-label">
                                  <Tooltip
                                    title="Enter the description of the group."
                                    placement="right"
                                  >
                                    <em
                                      className="icon ni ni-info"
                                      style={{
                                        color: "#6576ff",
                                      }}
                                    ></em>
                                  </Tooltip>{" "}
                                  Description{" "}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <div className="form-control-group">
                                <TextareaAutosize
                                  maxrows={4}
                                  name="group_desc"
                                  id="group_desc"
                                  aria-label=""
                                  placeholder=""
                                  inputProps={{ maxLength: 500 }}
                                  //maxLength={500}
                                  value={this.state.group_desc}
                                  helperText="Maximum 500 characters"
                                  onChange={this.handleChange}
                                  style={{
                                    width: "100%",
                                    height: "100px",
                                    borderColor: "rgba(0, 0, 0, 0.125)",
                                    borderRadius: "4px",
                                    padding: "5px",
                                  }}
                                  variant="outlined"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-4"></div>
                          <div style={{ clear: "both" }}></div>

                          <div className="col-lg-12">
                            <div className="form-group text-right">
                              <button
                                type="button"
                                onClick={() => this.formSave()}
                                className="btn btn-lg btn-primary"
                                disabled={this.state.disabled}
                              >
                                <em className="icon ni ni-save"></em> &nbsp;
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Table 5th Col End */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CollateralsAddGroup);
